import React, { Component } from 'react';


class cardList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataDid:0,
      data:[],
      isDid:false
    };
  }
  componentWillMount(){} 
componentDidMount(){

}
componentDidUpdate(){
  
  
}
componentWillReceiveProps (nextProps){
  let dataDid=0;
  if(nextProps.data){
   for(let i=0;i<nextProps.data.length;i++){
    if(nextProps.data[i].status==="1"){
      dataDid++;
    }
  }
  this.setState({
    dataDid:dataDid,
    data:nextProps.data,
    isDid:nextProps.isDid
  })
}
}
  render() {
    // console.log(this.state,'this.state.data')
    // if(this.state.isDid!==true){
      return (
        <div>
        <div className="que_list">
                <div className="que_top">
                  <p className="que_left">{this.props.title}</p>
                  <p className="que_right">{this.state.dataDid}/{this.state.data?this.state.data.length:"0"}</p>
                </div>
              <ul className="que_item">
              {
                this.props.data&&this.props.data.map((value,key)=>{
                  if(this.props.isDid!==true){
                    return(
                      <li key={key} className={(value.status)/1===1?"cardDid":""} >{key+1}</li>
                    )
                  }else{
                    if((value.status)/1!==1){
                      return(
                      <li key={key} className="">{key+1}</li>
                      )
                    }else{
                      if((value.correctness)/1!==1){
                        return(
                        <li key={key} className="cardErr">{key+1}</li>
                        )
                      }else{
                        return(
                          <li key={key} className="cardRight">{key+1}</li>
                          )
                      }
                    }
                  }
                })
              }
                
              </ul>
              </div>
        </div>
      );
    // }else{
    //   return (
    //     <div>
    //     <div className="que_list">
    //             <div className="que_top">
    //               <p className="que_left">{this.props.title}</p>
    //               <p className="que_right">{this.state.dataDid}/{this.state.data?this.state.data.length:"0"}</p>
    //             </div>
    //           <ul className="que_item">
    //           {
    //             this.state.data&&this.state.data.map((value,key)=>{
    //               if(value.cardList&&value.cardList.length>0&&value.cardList[0].status!=="1"){
    //                 return(
    //                   <li key={key} className="">{key+1}</li>
    //                  )
    //               }else{
                    
    //                 if(value.cardList&&value.cardList.length>0&&value.cardList[0].correctness!=="1"){
    //                   return(
    //                   <li key={key} className="cardErr">{key+1}</li>
    //                   )
    //                 }else{
    //                   return(
    //                     <li key={key} className="cardRight">{key+1}</li>
    //                     )
    //                 }
    //               }
             
    //             })
    //           }
                
    //           </ul>
    //           </div>
    //     </div>
    //   );
    // }
    
  }
}

export default cardList;
